import { render, staticRenderFns } from "./CompetitorGroupRenderer.vue?vue&type=template&id=e3e6665c&scoped=true&"
import script from "./CompetitorGroupRenderer.vue?vue&type=script&lang=js&"
export * from "./CompetitorGroupRenderer.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorGroupRenderer.vue?vue&type=style&index=0&id=e3e6665c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e6665c",
  null
  
)

/* custom blocks */
import block0 from "./CompetitorGroupRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports